import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const createCategory = async (formValues) => {
  const formData = new FormData();
  formData.append("CategoryName", formValues.CategoryName);
  formData.append("CategoryURL", formValues.CategoryURL);
  formData.append("PageTitle", formValues.PageTitle || "");
  formData.append("MetaDescription", formValues.MetaDescription || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("Featured", formValues.Featured.toString());
  formData.append("DisplayOrder", formValues.DisplayOrder.toString());
  formData.append("FullDescription", formValues.FullDescription);
  formData.append("ShortDescription", formValues.ShortDescription);

  if (formValues.ImageURLFile) {
    formData.append("ImageURLFile", formValues.ImageURLFile);
  }
  const response = await axiosInstance.post("product/category", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};
export const updateCategory = async (formValues) => {
  const formData = new FormData();
  formData.append("Id", formValues.Id);
  formData.append("CategoryName", formValues.CategoryName);
  formData.append("CategoryURL", formValues.CategoryURL);
  formData.append("PageTitle", formValues.PageTitle || "");
  formData.append("MetaDescription", formValues.MetaDescription || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("Featured", formValues.Featured.toString());
  formData.append("DisplayOrder", formValues.DisplayOrder.toString());
  formData.append("FullDescription", formValues.FullDescription);
  formData.append("ShortDescription", formValues.ShortDescription);

  if (formValues.ImageURLFile) {
    formData.append("ImageURLFile", formValues.ImageURLFile);
  } else {
    formData.append("ImageURLFile", null);
  }
  const response = await axiosInstance.put("product/category", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};

export const fetchCategories = async () => {
  const response = await axiosInstance.get("product/category", { headers });
  return response.data;
};
export const fetchCategoriesForReOrder = async () => {
  const response = await axiosInstance.get("product/category/for-re-order", {
    headers,
  });
  return response.data;
};
export const fetchCategoryDropdowns = async () => {
  const response = await axiosInstance.get("product/category/dropdown", {
    headers,
  });
  return response.data;
};

export const fetchCategoryById = async (id) => {
  const response = await axiosInstance.get(`product/category/${id}`, {
    headers,
  });
  return response.data;
};

export const publishCategory = async (id) => {
  return await await axiosInstance.patch(`product/category/${id}/publish`, {
    headers,
  });
};

export const unPublishCategory = async (id) => {
  return await await axiosInstance.patch(`product/category/${id}/unpublish`, {
    headers,
  });
};

export const markCategoryFeatured = async (id) => {
  return await await axiosInstance.patch(`product/category/${id}/featured`, {
    headers,
  });
};

export const markCategoryUnFeatured = async (id) => {
  return await await axiosInstance.patch(`product/category/${id}/unfeatured`, {
    headers,
  });
};

export const updateGalleryOrderService = async (orderData) => {
  const response = await axiosInstance.patch(
    `/product/category/update-order`,
    orderData,
    {
      headers,
    }
  );
  return response.data;
};

export const deleteCategory = async (id) => {
  return await axiosInstance.delete(`product/category/${id}`, { headers });
};
